module.exports = __webpack_public_path__ + "static/media/team4.bf6a0c0a.jpg";